module.exports = __webpack_public_path__ + "static/img/Service_concept.b8d2908.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/Service_concept.png
// module id = ogDH
// module chunks = 0